module.exports = __webpack_public_path__ + "img/abacus_type_7 (old).1fd3ddcf.png";